'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import ModalTitle from "../Modal/ModalTitle.js";
var DrawerTitle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ModalTitle, _extends({
    classPrefix: "drawer-title"
  }, props, {
    ref: ref
  }));
});
export default DrawerTitle;